import { gql } from 'graphql-request'

export namespace NotificationsMutations {
  export function markNotificationAsViewed() {
    return gql`
      mutation markNotificationAsViewed($notificationInfo: ViewedNotificationAlert!) {
        markNotificationAsViewed(notificationInfo: $notificationInfo) {
          id
        }
      }
    `
  }
}
